import React, { useState, useEffect } from "react";
import "./AddUserModal.css";
import Company from "../../Models/Store";
import CreateUserDto from "../../Models/CreateUserDto";
import MultiSelect from "../MultiSelect/MultiSelect";

type AddUserModalProps = {
    companies: Company[];
    onClose: () => void;
    onSave: (data: CreateUserDto) => Promise<void> | void;
    mode?: "create" | "edit";
    initialValues?: Partial<CreateUserDto>;
    titleOverride?: string;
    submitLabelOverride?: string;
};

const AddUserModal: React.FC<AddUserModalProps> = ({
    onClose,
    onSave,
    companies,
    mode = "create",
    initialValues,
    titleOverride,
    submitLabelOverride,
}) => {
    const [email, setEmail] = useState("");
    const [role, setRole] = useState<"Admin" | "User">("User");
    const [storeIds, setStoreIds] = useState<string[]>([]);
    
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setEmail(initialValues?.email ?? "");
        setRole(initialValues?.role ?? "User");
        setStoreIds(initialValues?.storeIds ?? []);
        
    }, [initialValues]);

    const title =
        titleOverride ??
        (mode === "edit" ? "Modifier un Utilisateur" : "Ajouter un Utilisateur");
    const submitLabel =
        submitLabelOverride ?? (mode === "edit" ? "Mettre à jour" : "Enregistrer");

    const onSubmit = async () => {
        setError(null);

        const trimmedEmail = email.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!trimmedEmail) {
            setError("Veuillez saisir un email.");
            return;
        }
        
        if (!emailRegex.test(trimmedEmail)) {
            setError("L'adresse email saisie n'est pas valide.");
            return;
        }

        setSaving(true);
        try {
            await onSave({
                email: email.trim(),
                role,
                storeIds,
            });
        } catch(e: any) {
            if (e.status === 401){
                setError("Échec de l'enregistrement. Nous vous invitons à rafraichir la page puis réessayer.");
            } else {
                setError("Échec de l'enregistrement. Veuillez réessayer.");
            }
            setSaving(false);
            return;
        }
        setSaving(false);
    };

    return (
        <div className="add-user-modal-backdrop">
            <div className="add-user-modal">
                <h3>{title}</h3>

                {error && <div className="form-error">{error}</div>}

                <div className="row">
                    <label>Email</label>
                    <input
                        type="email"
                        placeholder="nom@domaine.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={saving}
                    />
                </div>

                <div className="row">
                    <label>Rôle *</label>
                    <input
                        value={role}
                        disabled={true}
                    />
                </div>

                <div className="picker two-cols">
                    <div className="picker-column">
                        <MultiSelect
                            label="Magasins"
                            items={companies.map((c) => ({ id: c.id, name: c.name }))}
                            selectedIds={storeIds}
                            onChange={setStoreIds}
                            placeholder="Sélectionner des magasins…"
                            disabled={saving}
                        />
                    </div>
                </div>
                * Veuillez procéder à la modification du rôle directement dans Lumapps.
                <div className="add-user-modal-actions">
                    <button onClick={onSubmit} disabled={saving}>
                        {saving ? "Enregistrement..." : submitLabel}
                    </button>
                    <button onClick={onClose} disabled={saving}>
                        Annuler
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddUserModal;
